import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface ScrollId {
  categoryId: string;
  partId: string;
}

@Injectable({ providedIn: 'root' })
export class PakCatalogService {
  private replacementProductId$ = new BehaviorSubject<string | null>(null);
  public closeCatalogDialogInPak = new Subject<void>();
  private scrollId: ScrollId | null = null;

  public getScrollId(): ScrollId | null {
    return this.scrollId;
  }

  public setScrollId(scrollId: ScrollId): void {
    this.scrollId = scrollId;
  }

  public resetScrollId(): void {
    this.scrollId = null;
  }

  public setReplacementProductId(replacementProductId: string): void {
    this.replacementProductId$.next(replacementProductId);
  }

  public resetReplacementProductId(): void {
    this.replacementProductId$.next(null);
  }

  public getReplacementProductId(): Observable<string | null> {
    return this.replacementProductId$.asObservable();
  }

  public getCloseCatalogDialogInPak(): Observable<void> {
    return this.closeCatalogDialogInPak.asObservable();
  }

  public setCloseCatalogDialogInPak(): void {
    this.closeCatalogDialogInPak.next();
  }
}
